export default __webpack_public_path__ + "static/media/type-23.a292c494.jpg";